export const dataType = {
  NUMBER: 2,
  DECIMAL: 4,
  TEXT: 8,
  PERCENT: 16,
  PERCENT_BASED: 6,
  DATE_TIME: 32,
  REF: 64,
  ACTION: 128,
  CURRENCY: 256,
  BUY_SELL: 512,
  EDIT_CANCEL: 1024,
  FUND_EDIT_CANCEL:2024,
  STATUS: 2048,
  SYMBOL: 4096,
  IPO_CELL_RENDER: 8192,
  FUND_CELL_RENDER: 21921,
  CA_CELL_RENDER: 16384,
  SHORT_DATE: 32768,
  LONG_DATE: 65536,
  ORDER_CELL_RENDER: 131072,
  AVG_PRICE: 262144,
  FLOATING_PL_PERCENT: 524288,
  TRANSACTION_HISTORY_STATUS: 1048576,
  STOCK_NAME: 2097152,
  CASH: 209715282,
  Time_CHANGE: 952766,
  SHOW_PDF:6696,
  TRADE_DATE_TIME:114514,
  FUBON_ORDER_ACTION:9527,
  NO_DATA:347,
  STOP_PRICE:694,
  FUNDS_QUANTITY:1388
}